import { useRouter } from 'next/router'
import { useBogo } from '@mc/bogo-utils'
import { Conditional, ShowIf } from '@mc/conditional-rendering'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { usePromotion } from '@mc/promo-utils'
import {
  PromoGiftHero,
  useGiftPagePromoHeroImage,
  Pen5108CtaContentWrapper,
} from '@mc/promos'
import CTA from 'components/CTA'
import Image from 'components/LegacyImage'
import { STATIC_IMAGE_BASE } from 'libs/constants'
import classes from './Hero.module.scss'

export const Hero = () => {
  const { t } = useTranslation('@mc/next')
  const { query } = useRouter()

  const { isPromotionOn } = usePromotion()
  const { isBogoOfferEligible } = useBogo()

  const heroImageUrl = useGiftPagePromoHeroImage(
    `${STATIC_IMAGE_BASE}/gift-hero.jpeg`,
  )

  return (
    <section className={`${classes.hero} d-flex align-items-center`}>
      <div className={classes.ribbon}>
        <Image
          alt={t('gift.hero.imageAlt')}
          priority
          src={heroImageUrl}
          layout='fill'
          objectFit='cover'
          quality={85}
        />
      </div>

      <div className='container'>
        <div className={classes.text}>
          <Conditional>
            <ShowIf condition={isPromotionOn || isBogoOfferEligible}>
              <PromoGiftHero />
            </ShowIf>
            <ShowIf isDefault>
              <DefaultHero />
            </ShowIf>
          </Conditional>

          <Pen5108CtaContentWrapper
            control={
              <CTA
                className={classes.cta}
                trackProps={{
                  action: 'aap-gift-landing',
                  content_type: 'product',
                  location: 'gifting-landing-hero',
                }}
                href={paths.checkoutGift(query)}
              >
                {t('gift.hero.cta')}
              </CTA>
            }
            location='gifting-landing-hero'
            query={query}
            CTA={CTA}
          />
        </div>
      </div>
    </section>
  )
}

const DefaultHero = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <>
      <h1 className='mc-text-h1 mc-mb-2'>{t('gift.hero.title')}</h1>
      <p className='mc-text-large mc-opacity--muted mc-mb-8'>
        {t('gift.hero.subtitle')}
      </p>
    </>
  )
}
